// extracted by mini-css-extract-plugin
module.exports = {"selector":"styles_selector__1xdwv"};